import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { Provider } from '../../lib/__generated/sdk';
import { getProviderContentContainerStyles, providerQuotesStyles } from './ProviderDetailsPage.styles';

interface ProviderQuotesProps {
	provider: Provider & {
		quote?: string | null;
		firstName?: string | null;
		lastName?: string | null;
	};
}

export default function ProviderQuotes({ provider }: ProviderQuotesProps) {
	const theme = useTheme();
	const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

	// Only render if the provider has a quote
	if (!provider.quote) {
		return null;
	}

	return (
		<Box data-testid="provider_quotes_container" sx={getProviderContentContainerStyles}>
			<Box sx={providerQuotesStyles.container}>
				<Typography
					variant={isMobileScreen ? 'header3' : 'header2'}
					color="text.primary"
					component="blockquote"
					data-testid="provider_quotes_text"
					sx={providerQuotesStyles.quoteText}
				>
					{provider.quote}
				</Typography>
				<Typography
					variant={isMobileScreen ? 'bodyMediumSemiBold' : 'bodyLargeSemiBold'}
					color="text.secondary"
					component="cite"
					data-testid="provider_quotes_attribution"
					sx={providerQuotesStyles.attribution}
				>
					Dr. {provider.firstName} {provider.lastName}
				</Typography>
			</Box>
		</Box>
	);
}
